import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, Params, PRIMARY_OUTLET } from '@angular/router';
import { filter } from 'rxjs/operators';
import { IBreadcrumb } from './breadcrumbs.model';
import { BreadcrumbsService } from './breadcrumbs.service';


@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  encapsulation: ViewEncapsulation.None
})
export class BreadcrumbsComponent implements OnInit {

  // The breadcrumbs of the current route
  private currentBreadcrumbs: IBreadcrumb[];
  // All the breadcrumbs
  public breadcrumbs: IBreadcrumb[];

  @Input()
  public allowBootstrap: boolean;

  @Input()
  public addClass: string;

  /**
   * <pre>
   * <b>Method name: constructor</b>
   * contructor for component
   * @param breadcrumbService type BreadcrumbsService
   * @param activatedRoute type ActivatedRoute
   * @param router type Router
   */
  public constructor(private breadcrumbService: BreadcrumbsService, private activatedRoute: ActivatedRoute, private router: Router) {
    breadcrumbService.get().subscribe((breadcrumbs: IBreadcrumb[]) => {
      this.breadcrumbs = breadcrumbs;
      const type = JSON.parse(localStorage.getItem("notitficationTypeSign"));
      const checkMan = breadcrumbs.find(ele => ele.url == "/home-enterprise/sign-batch-result" );
      const checkMan2 = breadcrumbs.find(ele => ele.url == "/home-enterprise/view-multiple-sign-flow" );
      if(type == 90 && checkMan){
        this.breadcrumbs.forEach(ele => {
          if(ele.label == "breadcrumbs.document_search_sign"){
            ele.label = "breadcrumbs.enterprise_waiting_confirm_doc"
          }
        })
      }
    });

    const ROUTE_DATA_BREADCRUMB = 'breadcrumb';
    const ROUTE_PARAM_BREADCRUMB = 'breadcrumb';
    const PREFIX_BREADCRUMB = 'prefixBreadcrumb';

    // subscribe to the NavigationEnd event
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      // reset currentBreadcrumbs
      this.currentBreadcrumbs = [];


      // get the root of the current route
      let currentRoute: ActivatedRoute = this.activatedRoute.root;


      // set the url to an empty string
      let url = '';

      // iterate from activated route to children
      while (currentRoute.children.length > 0) {
        const childrenRoutes: ActivatedRoute[] = currentRoute.children;
        let breadCrumbLabel = [];

        // iterate over each children
        childrenRoutes.forEach(route => {
          // Set currentRoute to this route
          currentRoute = route;
          // Verify this is the primary route
          if (route.outlet !== PRIMARY_OUTLET) {
            return;
          }

          const hasData = (route.routeConfig && route.routeConfig.data);
          const hasDynamicBreadcrumb: boolean = route.snapshot.params.hasOwnProperty(ROUTE_PARAM_BREADCRUMB);

          if (hasData || hasDynamicBreadcrumb) {

            /*
             Verify the custom data property "breadcrumb"
             is specified on the route or in its parameters.

             Route parameters take precedence over route data
             attributes.
             */
            if (hasDynamicBreadcrumb) {
              breadCrumbLabel = route.snapshot.params[ROUTE_PARAM_BREADCRUMB].replace(/_/g, ' ');
            } else if (route.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
              breadCrumbLabel = route.snapshot.data[ROUTE_DATA_BREADCRUMB];
            }

            // Get the route's URL segment
            const routeURL: string = route.snapshot.url.map(segment => segment.path).join('/');
            url += `/${routeURL}`;

            // Cannot have parameters on a root route
            if (routeURL.length === 0) {
              route.snapshot.params = {};
            }
            // Add breadcrumb
            const breadcrumb: IBreadcrumb = {
              label: breadCrumbLabel[0],
              params: route.snapshot.params,
              url,
              highlight: url.includes('add-document') ? true : false
            };
            const breadcrumb1: IBreadcrumb = {
              label: breadCrumbLabel[1],
              params: route.snapshot.params,
              url,
              highlight: url.includes('add-document') ? true : false
            };

            // Add the breadcrumb as 'prefixed'. It will appear before all breadcrumbs
            if (route.snapshot.data.hasOwnProperty(PREFIX_BREADCRUMB)) {
              this.breadcrumbService.storePrefixed(breadcrumb);
            } else if (breadcrumb.label !== undefined) {
              this.currentBreadcrumbs.push(breadcrumb);
              if (breadCrumbLabel.length > 1) {
                this.currentBreadcrumbs.push(breadcrumb1);
              }
            }
          }
        });
        this.breadcrumbService.store(this.currentBreadcrumbs);
      }
    });
  }
  public hasParams(breadcrumb: IBreadcrumb) {
    return Object.keys(breadcrumb.params).length ? [breadcrumb.url, breadcrumb.params] : [breadcrumb.url];
  }
  public ngOnInit() {
  }
}
